import {DisplayAdContainer} from '../../../../common/containers/DisplayAdContainer/DisplayAdContainer';
import {t} from '../../../../common/getTranslations';
import {LogTabType} from '../../../../common/LogTabType.enum';
import {TabPositionSticky} from '../../../../common/presentational/TabPositionSticky';
import {twMerge} from '../../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../../logging/logEvent';
import {PageViewCustomPropsDataKey} from '../../../../logging/PageViewCustomPropsDataKey.enum';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {showRankingHelpDialog} from '../../../../main/showRankingHelpDialog';
import {Icon} from '../../../atoms/Icon/Icon';
import {IconType} from '../../../atoms/Icon/IconType.enum';
import {BelowDefaultTab} from '../../../organisms/BelowDefaultTab/BelowDefaultTab';
import {Dialog} from '../../../organisms/Dialog';
import {MainTab} from '../../../organisms/MainTab/MainTab';
import {StaticLandingRankingProps} from './StaticLandingRankingProps.interface';

export function StaticLandingRanking({
  isMobile,
  isWebView,
  rankingTime,
  categoryList,
  currentCategoryUid,
  rankingTypeList,
  currentRankingType,
  subcategoryList,
  currentSubcategoryUid,
  currentCategoryName,
  currentSubcategoryName,
  currentRankingTypeName,
  isShowSubcategoryDialog,
  isShowRankingTypeDialog,
  className,
  showSubcategoryDialog,
  hideSubcategoryDialog,
  showRankingTypeDialog,
  hideRankingTypeDialog,
  onClickCategoryTabItem,
  onClickSubcategoryItem,
  onClickRankingTypeItem,
  displayAd,
  children,
}: StaticLandingRankingProps) {
  const hasSubcategory = subcategoryList && subcategoryList.length > 0;
  const hasRankingType = rankingTypeList && rankingTypeList.length > 0;

  return (
    <div className={twMerge('flex flex-col w-full mb-15pxr grow', className)}>
      <TabPositionSticky
        depth={1}
        disabled={!isMobile}
        isMobile={isMobile}
        isWebView={isWebView}
      >
        <MainTab
          className={!isMobile ? 'px-15pxr' : undefined}
          isMobile={isMobile}
          title={t('landing_ranking')}
          tabItems={categoryList}
          currentTabItemId={currentCategoryUid}
          showBorder={true}
          onClickTab={clickedTabItemId =>
            onClickCategoryTabItem &&
            onClickCategoryTabItem(clickedTabItemId as number)
          }
          logTabType={LogTabType.Category}
        />
      </TabPositionSticky>
      <TabPositionSticky
        depth={2}
        disabled={!isMobile}
        isMobile={isMobile}
        isWebView={isWebView}
      >
        <BelowDefaultTab className="px-15pxr">
          {rankingTime && (
            <BelowDefaultTab.TextLabel>
              <div
                className="flex items-center cursor-pointer space-x-4pxr"
                onClick={() => {
                  showRankingHelpDialog({isMobile});
                }}
              >
                <span>{rankingTime}</span>
                <Icon type={IconType.ButtonHelpS} />
              </div>
            </BelowDefaultTab.TextLabel>
          )}
          {hasSubcategory && (
            <BelowDefaultTab.SelectBox
              onClick={showSubcategoryDialog}
              {...{
                [PageViewCustomPropsDataKey.PageGenreFilter]: `page_genre_filter=${currentSubcategoryName}`,
              }}
              iconType={IconType.TabFilter}
            >
              {currentSubcategoryName}
            </BelowDefaultTab.SelectBox>
          )}
          {hasRankingType && (
            <BelowDefaultTab.SelectBox
              onClick={showRankingTypeDialog}
              {...{
                [PageViewCustomPropsDataKey.PageSort]: `page_sort=${currentRankingTypeName}`,
              }}
              iconType={IconType.TabFilter}
            >
              {currentRankingTypeName}
            </BelowDefaultTab.SelectBox>
          )}
        </BelowDefaultTab>
      </TabPositionSticky>
      {hasSubcategory && (
        <Dialog
          isOpen={!!isShowSubcategoryDialog}
          onClose={hideSubcategoryDialog}
          isMobile={isMobile}
          {...putTiaraObjectProps({
            customProps: {
              page_category_filter: currentCategoryName,
              page_genre_filter: currentSubcategoryName,
              page_sort: currentRankingTypeName,
            },
          })}
        >
          <Dialog.Dimmed />
          <Dialog.List className="space-y-0">
            {subcategoryList.map(subcategory => (
              <Dialog.Option
                key={subcategory.id}
                onClick={e =>
                  LOG_CLICK_EVENT('장르필터_클릭', e, () =>
                    onClickSubcategoryItem(subcategory.param)
                  )
                }
                isChecked={subcategory.param === currentSubcategoryUid}
                {...putTiaraObjectProps({
                  click: {
                    layer1: '리스팅옵션',
                    copy: subcategory.name,
                  },
                })}
              >
                {subcategory.name}
              </Dialog.Option>
            ))}
          </Dialog.List>
          <Dialog.BottomCombination>
            <Dialog.Button onClick={hideSubcategoryDialog}>
              {t('common_cancel_button')}
            </Dialog.Button>
          </Dialog.BottomCombination>
        </Dialog>
      )}
      {hasRankingType && (
        <Dialog
          isOpen={!!isShowRankingTypeDialog}
          onClose={hideRankingTypeDialog}
          isMobile={isMobile}
          {...putTiaraObjectProps({
            customProps: {
              page_category_filter: currentCategoryName,
              page_genre_filter: currentSubcategoryName,
              page_sort: currentRankingTypeName,
            },
          })}
        >
          <Dialog.Dimmed />
          <Dialog.List className="space-y-0">
            {rankingTypeList.map(rankingType => (
              <Dialog.Option
                key={rankingType.id}
                onClick={e => {
                  LOG_CLICK_EVENT('정렬_클릭', e, () =>
                    onClickRankingTypeItem(rankingType.param)
                  );
                }}
                isChecked={rankingType.param === currentRankingType}
                {...putTiaraObjectProps({
                  click: {
                    layer1: '리스팅옵션',
                    copy: rankingType.name,
                  },
                })}
              >
                {rankingType.name}
              </Dialog.Option>
            ))}
          </Dialog.List>
          <Dialog.BottomCombination>
            <Dialog.Button onClick={hideRankingTypeDialog}>
              {t('common_cancel_button')}
            </Dialog.Button>
          </Dialog.BottomCombination>
        </Dialog>
      )}
      {displayAd && isMobile && (
        <DisplayAdContainer
          displayAd={displayAd}
          className="mx-11pxr mb-5pxr"
        />
      )}
      <div className="flex flex-col w-full grow">{children}</div>
    </div>
  );
}
